import React from "react";
import {Link} from "react-router-dom";
class BlackTitleBar extends React.Component {
  render() {
    return (
      <section
        className="section"
        style={{ background: "#000", padding: "20px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center section_title">
                <h1
                  className="font-weight-bold wherehome-white"
                  style={{ color: "#fff" }}
                >
                  See Mighty benefits and how it works{" "}
                  <Link to="/sale">
                    <i className="mdi mdi-arrow-right-bold-circle-outline" />
                  </Link>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default BlackTitleBar;



// WEBPACK FOOTER //
// ./src/pages/getwifius/BlackTitleBar.js